import React, { useEffect, useState } from 'react';
import './PwaInstallBanner.css';

const DISMISS_KEY = 'cx_pwa_install_dismissed';

const PwaInstallBanner = () => {
  const [deferredPrompt, setDeferredPrompt] = useState(null);
  const [visible, setVisible] = useState(false);
  const [isStandalone, setIsStandalone] = useState(false);
  const [iosHint, setIosHint] = useState(false);

  useEffect(() => {
    const standalone =
      window.matchMedia('(display-mode: standalone)').matches ||
      window.navigator.standalone === true;
    setIsStandalone(standalone);
    if (standalone) return;

    if (localStorage.getItem(DISMISS_KEY) === '1') return;

    const isIos = /iphone|ipad|ipod/i.test(window.navigator.userAgent);
    const isSafari = /^((?!chrome|android).)*safari/i.test(window.navigator.userAgent);
    if (isIos && isSafari) {
      setIosHint(true);
      setVisible(true);
      return;
    }

    const onBeforeInstall = (e) => {
      e.preventDefault();
      setDeferredPrompt(e);
      setVisible(true);
    };
    window.addEventListener('beforeinstallprompt', onBeforeInstall);
    return () => window.removeEventListener('beforeinstallprompt', onBeforeInstall);
  }, []);

  if (isStandalone || !visible) return null;

  const dismiss = () => {
    localStorage.setItem(DISMISS_KEY, '1');
    setVisible(false);
  };

  const install = async () => {
    if (!deferredPrompt) return;
    deferredPrompt.prompt();
    try {
      await deferredPrompt.userChoice;
    } catch {
      /* ignore */
    }
    setDeferredPrompt(null);
    setVisible(false);
  };

  return (
    <div className="pwa-install-banner" role="region" aria-label="Install app">
      <div className="pwa-install-banner__copy">
        <strong>Install CakeXpress</strong>
        <span>
          {iosHint
            ? 'Tap Share → Add to Home Screen for the mobile app.'
            : 'Add the app to your phone for a faster mobile UI.'}
        </span>
      </div>
      <div className="pwa-install-banner__actions">
        {!iosHint && deferredPrompt ? (
          <button type="button" className="pwa-install-banner__btn" onClick={install}>
            Install
          </button>
        ) : null}
        <button type="button" className="pwa-install-banner__dismiss" onClick={dismiss} aria-label="Dismiss">
          ×
        </button>
      </div>
    </div>
  );
};

export default PwaInstallBanner;
